import { atom } from '@reatom/framework'

type SecretType = 'phrase' | 'privateKey'
export const reatomWalletImportForm = () => {
  const secretTypeAtom = atom<SecretType>('phrase', 'secretTypeAtom')

  return {
    secretTypeAtom,
  }
}

export const reatomWalletImportDialog = atom(false, 'reatomWalletImportDialog')
